import type { Artwork } from "./types";

export const selfPortraits: Artwork[] = [
  {
    id: "sp1",
    title: "alone",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/alone.png",
    fullImage: "/gallery/self portraits/full/alone.png",
    date: "2026-02-08",
  },
  {
    id: "sp2",
    title: "angely",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/angely.png",
    fullImage: "/gallery/self portraits/full/angely.png",
    date: "2026-02-08",
  },
  {
    id: "sp3",
    title: "atlantis",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/atlantis.png",
    fullImage: "/gallery/self portraits/full/atlantis.png",
    date: "2026-02-08",
  },
  {
    id: "sp4",
    title: "meeeee",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/meeeee.png",
    fullImage: "/gallery/self portraits/full/meeeee.png",
    date: "2026-02-08",
  },
  {
    id: "sp5",
    title: "Photo 2026-02-08, 1 11 03 AM (1)",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/photo-2026-02-08-1-11-03-am-1.jpg",
    fullImage: "/gallery/self portraits/full/Photo 2026-02-08, 1 11 03 AM (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "sp6",
    title: "Photo 2026-02-08, 1 11 03 AM",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/photo-2026-02-08-1-11-03-am.jpg",
    fullImage: "/gallery/self portraits/full/Photo 2026-02-08, 1 11 03 AM.jpg",
    date: "2026-02-08",
  },
  {
    id: "sp7",
    title: "Photo 2026-02-08, 1 22 45 AM (1)",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/photo-2026-02-08-1-22-45-am-1.jpg",
    fullImage: "/gallery/self portraits/full/Photo 2026-02-08, 1 22 45 AM (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "sp8",
    title: "Photo 2026-02-08, 1 22 45 AM",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/photo-2026-02-08-1-22-45-am.jpg",
    fullImage: "/gallery/self portraits/full/Photo 2026-02-08, 1 22 45 AM.jpg",
    date: "2026-02-08",
  },
  {
    id: "sp9",
    title: "selfportrate",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/selfportrate.png",
    fullImage: "/gallery/self portraits/full/selfportrate.png",
    date: "2026-02-08",
  },
  {
    id: "sp10",
    title: "thats not me",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/thats-not-me.png",
    fullImage: "/gallery/self portraits/full/thats not me.png",
    date: "2026-02-08",
  },
  {
    id: "sp11",
    title: "wired",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/wired.png",
    fullImage: "/gallery/self portraits/full/wired.png",
    date: "2026-02-08",
  },
  {
    id: "sp12",
    title: "zapy panchiko",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/zapy-panchiko.png",
    fullImage: "/gallery/self portraits/full/zapy panchiko.png",
    date: "2026-02-08",
  },
  {
    id: "sp13",
    title: "zapychan",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/zapychan.png",
    fullImage: "/gallery/self portraits/full/zapychan.png",
    date: "2026-02-08",
  },
  {
    id: "sp14",
    title: "zpay",
    year: 2026,
    medium: "me irl",
    thumbnail: "/gallery/self portraits/thumbs/zpay.png",
    fullImage: "/gallery/self portraits/full/zpay.png",
    date: "2026-02-08",
  },
];
